import React, { useMemo } from 'react';
import PreviewCardsGallery from 'components/UI/PreviewCardsGallery';
import ProjectGalleryCard from 'components/cards/ProjectGalleryCard';
import { projectsGridConfig } from './constans';

function Cases({ className, projects, pageSize = 4, withShowMore, layout = 'projects', gallery }) {
  const navItems = useMemo(() => projects?.map(item => item.project_url), [projects]);

  return (
    <PreviewCardsGallery
      className={className}
      CardComponent={ProjectGalleryCard}
      items={projects}
      pageSize={pageSize}
      navItems={navItems}
      gridConfig={projectsGridConfig}
      withShowMore={withShowMore}
      layout={layout}
      gallery={gallery}
    />
  );
}

export default Cases;
